import React, { useEffect } from "react";

export default function OutboundRedirect() {
  useEffect(() => {
    fetch("https://halper.ai/api/outbound/counter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ campaign: "uae-1" }),
    }).catch(() => {});

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /android/i.test(userAgent);

    setTimeout(() => {
      if (isIOS) {
        window.location.href = "https://apps.apple.com/il/app/halper/id6745568939";
      } else if (isAndroid) {
        window.location.href =
          "https://play.google.com/store/search?q=Halper%20Ai&c=apps&hl=ru";
      } else {
        window.location.href = "https://halper.ai/apps";
      }
    }, 250);
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Helvetica, sans-serif",
        color: "#555",
        fontSize: "18px",
      }}
    >
    </div>
  );
}
